import React, {useEffect, useState} from "react";
import {
    StepContainer,
    StepLabelContainer,
    StepPrimaryLabel,
    StepIcon,
    Step,
    StepConnector,
    StepProgressBar,
    StepWrapper,
    StepContent,
    Button,
    IconChevronRight,
    IconChevronLeft,
    BUTTON_VARIANTS,
    Loader,
    MultiToasts,
    TOAST_POSITIONS,
    TOAST_VISIBILITY_DURATIONS,
    TOAST_VARIANTS
  } from 'cdk-radial';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import './styles/MIStepper.scss';
import { contentMapper } from "./ContentMapper";
import { CONSTANTS } from "./constants";
import { METADATA_CONSTANTS } from "../../../../../constants/metadataConstant";
import { updateCppForAppV2 } from "../../../../../redux/connectedComponent/ManageIntegrationsV2/ManageIntegrationsV2.slice";
import {
  bulkConnectionEnable,
  bulkConnectionDisable,
} from '../../../../../redux/connectedComponent/manageBulkConnections/manageBulkConnectioins.slice';
import { disableNext as disableNextAction } from "../../../../../redux/connectedComponent/ManageIntegrationsV2/ManageIntegrationsV2.slice";
import { updateDMSAccountsDetailsForApp } from "../../../../../redux/connectedComponent/updateDMSAccounts/updateDMSAccounts.slice";
import Overlay from "../../../../Overlay/Overlay";

const CUSTOM_STYLE = {
  width: "660px"
};

const COLOR_STROKE = 'rgba(21,27,37,0.4)';

export const MIStepper = ({additionalData={additionalData}, solutionData = {}, apiDetails = {}, isNewApi, subscriptionData = {}}) => {
    const state = useSelector(state => state);
    const dispatch = useDispatch();
    const { authenticationToken } = state.loginDetailsSlice;
    const {
      enableSuccess,
      enablePending,
      enableFailed,
      disableSuccess,
      disablePending,
      disableFailed,
    } = state.manageBulkConnectionsSlice;

    const apiIntegrationDetails = state.apiIntegrationSlice.ApiIntegrationsDetails;
    const {
      disableNext,
      requestedCppStatuses,
      requestedIntegrationStatuses,
      dmsLocationSpecificAccounts,
      requestedAPIFields,
      requestedApiSubscriptionSettings,
      updateCppPending,
      updateCppError,
      updateCppSuccess,
      isConsentSaveSuccess,
    } = state.ManageIntegrationsV2Slice;
    const { dmsAccountsSupport, privacyProtectionSupport, apiFieldSelections, dealerApiPreferences } =
      state.ConfigurationsSlice;
    const [locations, setLocations] = useState([]);
    const [apiCppEnabled, setApiCppEnabled] = useState(false);
    const [toastTriggered, setToastTriggered] = useState({
      enableSuccess: false,
      enableFailed: false,
      disableSuccess: false,
      disableFailed: false,
      cppFailed: false,
      cppSuccess: false
    });

    const  [enabledLocations, setEnabledLocations] = useState(0);
    const  [disabledLocations, setDisabledLocations] = useState(0);
    // payload data 
    const {userEmail, decodedToken: {firstName, lastName} } = state.loginDetailsSlice
    //local state
    const [activeStep, setActiveStep] = useState(1);
    const [isLastStep, setIsLastStep] = useState(false);
    const [stepList, setStepList] = useState([
      CONSTANTS.SELECT_LOCATIONS,
      CONSTANTS.REVIEW_TERMS,
    ]);
    const [steps, setSteps] = useState([]);
    const [toasts, setToasts] = useState([]);
    const [stepNumberToContentMap, setStepNumberToContentMap] = useState({});
    const [showDeactivationDialog, setShowDeactivationDialog] = useState(false);

    // toast notification functions

    const removeToast = toastId => {
      setToasts(ps => ps.filter(t => t.id !== toastId));
    };
  
    const addToast = userDef => {
      const id = userDef.id || `${Math.random()}_${Date.now()}`.substring(2);
      const def = {
        visibilityDuration: TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS,
        ...userDef,
        id,
        onVisibilityDurationEnd: userDef.onVisibilityDurationEnd
          || (() => removeToast(id)),
        actions: userDef.actions || [{
          text: 'Dismiss',
          onClick: () => removeToast(id)
        }]
      };
      setToasts(ps => {
        return [def, ...ps];
      });
    };
  
    // predefined toast types for convenience.
    const enableToast = () => addToast({
      content: (
        <div className="toast_notifications__content">
          API successfully enabled for {enabledLocations}{' '}
          location(s).
        </div>
      ),
      variant: TOAST_VARIANTS.POSITIVE
    });
    const disableToast = () => addToast({
      content: (
        <div className="toast_notifications__content">
          API successfully disabled for {disabledLocations}{' '}
          location(s).
        </div>
      ),
      variant: TOAST_VARIANTS.POSITIVE
    });
    const cppToast = () => addToast({
      content: (
        <div className="toast_notifications__content">
          Updated Consumer Privacy Protection settings.
        </div>
      ),
      variant: TOAST_VARIANTS.POSITIVE
    });
    const enableFailedToast = () => addToast({
      content: (
        <div className="toast_notifications__content">
          Some error occurred while saving user request. Failed to
          enable API for {enabledLocations} location(s).
        </div>
      ),
      variant: TOAST_VARIANTS.NEGATIVE
    });
    const disableFailedToast = () => addToast({
      content: (
        <div className="toast_notifications__content">
          Some error occurred while saving user request. Failed to
          disable API for {disabledLocations} location(s).
        </div>
      ),
      variant: TOAST_VARIANTS.NEGATIVE
    });
    const cppFailedToast = () => addToast({
      content: (
        <div className='toast_notifications__content'>
          Failed to save Consumer Privacy Protection settings.
        </div>
      ),
      variant: TOAST_VARIANTS.NEGATIVE
    });

    // new api changes for /enable call

    const getNewCppOptOuts = () => {
      const expandedOptOuts = {};
      for (const [orgId, optOut] of Object.entries(requestedCppStatuses)) {
        expandedOptOuts[orgId] = {
          [additionalData.apiDetails.id]: optOut
        };
      }
      return expandedOptOuts;
    };

    const isPending = (status, requested_status) => {
      return status ? !status.includes(requested_status) : true;
    };

    const getLocations = () => {
    const { locationsGroupByApi = {} } = apiIntegrationDetails;
    const locations =
      locationsGroupByApi[additionalData.apiDetails.api];
    let subscribedLocations = [];
    if (locations) {
      additionalData.subscriptionData.forEach((dsDealer, index) => {
        let flag = 0;
        locations.forEach((location) => {
          if (
            (location.entitycmfNumber &&  dsDealer.entitycmfNumber === location.entitycmfNumber) ||
            (location.entityId && dsDealer.entityId === location.entityId)
          ) {
            const { status, requested_status, createdOn, dmsAccount } = location;
            flag = 1;
            subscribedLocations.push({
              ...location,
              status: status,
              requested_status: requested_status,
              disabled: isPending(status, requested_status),
              createdOn: createdOn
                ? moment(createdOn).format('MM/DD/YYYY')
                : null,
              dmsAccount
            });
          }
        });
        if (flag === 0) {
          subscribedLocations.push({
            ...dsDealer,
            status: METADATA_CONSTANTS.STATUS.DISABLED,
            requested_status: METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE
          });
        }
      });
    } else {
     additionalData.subscriptionData.forEach((dealer,index)=>{
      subscribedLocations.push({
        ...dealer,
        status: METADATA_CONSTANTS.STATUS.DISABLED,
        requested_status: METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE,
      });
     })
    }
    setLocations(subscribedLocations);
      return subscribedLocations;
    }

    const getLocationsToBeDisabled = (locations) => {
      return locations.filter((loc) => requestedIntegrationStatuses[loc.entityId] === 'disable');
    };

    const getLocationsToBeEnabled = (locations) => {
      return locations.filter((loc) => requestedIntegrationStatuses[loc.entityId] === 'enable');
    };

    const handleSave = async () => {
      dispatch(disableNextAction(true));
      const solutionId = solutionData.id;
      const { apiDisplayName = '', api, id } = additionalData.apiDetails;
      const selectedPlanId = additionalData.selectedPlanId;

      let consentedEntityId = '';
      let asyncIntegrationId;
      if (!solutionData.isAppNotListed) {
        const {
          registration_details: { api_details },
        } = solutionData;
        let selectedAPI =
          api_details &&
          api_details.filter(
            (apiDetails) => apiDetails && apiDetails.id === id
          );
        asyncIntegrationId =
          selectedAPI &&
          Array.isArray(selectedAPI) &&
          selectedAPI[0] &&
          selectedAPI[0].asyncIntegrationId;
      }
      if (Object.values(requestedCppStatuses).some(entityOpted => entityOpted === true)) {
        setApiCppEnabled(true);
        dispatch(
          updateCppForAppV2({
            appId: solutionId,
            optOuts: getNewCppOptOuts(),
            token: authenticationToken,
          })
        );
      }

      const payload = {
        email: userEmail,
        firstName,
        lastName,
        solutionId: solutionId,
        api,
        apiProviderId: id,
        apiDisplayName,
        consentType: METADATA_CONSTANTS.CONSENT_TYPE.CONNECTION,
        selectedPlanId,
        apiType: additionalData.apiDetails.apiType || '',
        asyncIntegrationId: asyncIntegrationId || '',
      };
      const locationsToBeDisabled = getLocationsToBeDisabled(locations);
      const locationsToBeEnabled = getLocationsToBeEnabled(locations);
      if (locationsToBeEnabled.length > 0) {
        if (additionalData.isBulkSubscribed) {
          payload.isBulkSubscribed = true;
          payload.connectionIds = locationsToBeEnabled.map(
            (loc) => loc.connectionId
          );
          const entityList = locationsToBeEnabled.map(
            (location) => location.entityId
          );
          payload.entityIdList = entityList;
          let entityIdSubscriptionIdMapping = locationsToBeEnabled.map(
            (location) => ({
              entityId: location.entityId,
              subscriptionId: location.subscriptionId,
            })
          );
          payload.entityIdSubscriptionIdMapping = entityIdSubscriptionIdMapping;
          if (requestedAPIFields && requestedAPIFields?.length) {
            payload.apiFieldSelections = requestedAPIFields;
          }
          if (requestedApiSubscriptionSettings && Object.keys(requestedApiSubscriptionSettings).length) {
            payload.dealerApiPreferences = requestedApiSubscriptionSettings;
          }
        } else {
          const entityList = locationsToBeEnabled.map((location) => ({
            entityId: location.entityId,
            entitycmfNumber: location.entitycmfNumber,
          }));
          payload.entityIdList = entityList;
          if (requestedAPIFields && requestedAPIFields?.length) {
            payload.apiFieldSelections = requestedAPIFields;
          }
          if (requestedApiSubscriptionSettings && Object.keys(requestedApiSubscriptionSettings).length){
            payload.dealerApiPreferences = requestedApiSubscriptionSettings;
          }
        }
        const dmsConfig = {};
        if (isConsentSaveSuccess && Object.keys(payload).length) {
          if (dmsLocationSpecificAccounts.length) {
            if (additionalData.isBulkSubscribed) {
              const enabledLocations = getLocationsToBeEnabled(locations);
              enabledLocations.forEach((loc) => {
                let departments = [];
                const filtered = dmsLocationSpecificAccounts.filter(
                  (dmsLoc) => dmsLoc.entityId === loc.entityId
                );
                filtered.forEach((dms) => {
                  const filteredDepartments = dms.departments.map((dep) => ({
                    ...dep,
                    dmsType: dms.type,
                  }));
                  departments.push(...filteredDepartments);
                });

                let connectionId = loc.connectionId;
                if (additionalData?.apiDetails?.apiType === 'async-api') {
                  dmsConfig[loc.entityId] = departments;
                } else {
                  dmsConfig[connectionId] = departments;
                }
              });
              payload.dmsConfig = getBulkSubscribedDMSConfigForEachEntity(dmsConfig);
              dispatch(
                updateDMSAccountsDetailsForApp({
                  token: authenticationToken,
                  solutionId: solutionData.id,
                  updatedDMSAcounts: getDMSAccountForEachEntity(
                    dmsLocationSpecificAccounts,
                    payload.api
                  ),
                  isNewAPI: isNewApi,
                })
              );
            } else {
              payload.dmsAccount = getDMSAccountForEachEntity(
                dmsLocationSpecificAccounts,
                payload.api
              );
            }
          }
          dispatch(
            bulkConnectionEnable({ payload, token: authenticationToken })
          );
        }
        setEnabledLocations(locationsToBeEnabled.length);
      }
      if (locationsToBeDisabled.length > 0) {
        let disablePayload = JSON.parse(JSON.stringify(payload));
        if (additionalData.isBulkSubscribed) {
          disablePayload.isBulkSubscribed = true;
          disablePayload.connectionIds = locationsToBeDisabled.map(
            (loc) => loc.connectionId
          );
          const entityList = locationsToBeDisabled.map(
            (location) => location.entityId
          );
          disablePayload.entityIdList = entityList;
        } else {
          const entityList = locationsToBeDisabled.map(
            (location) => location.entityId
          );
          disablePayload.entityIdList = entityList;
        }
        setDisabledLocations(locationsToBeDisabled.length);
        dispatch(
          bulkConnectionDisable({
            payload: disablePayload,
            token: authenticationToken,
          })
        );
      }
    };

    const handleNavigation = () => {
      if (!isLastStep) {
        setShowDeactivationDialog(true);
        //determine if only deactivation is requested i.e. no dealership location has been chosen for activation
        for (const entityId in requestedIntegrationStatuses) {
          if (requestedIntegrationStatuses[entityId] === 'enable') {
            setShowDeactivationDialog(false);
            setActiveStep((s) => s + 1);
            break;
          }
        }
      } else {
        handleSave();
      }
    };

    useEffect(() => {
      const apiId = apiDetails.id?.replace('api-v2-', '');
      
      //check if API supports DMS configurations
      dmsAccountsSupport?.[apiId]?.length && setStepList(s => [...s, 'Manage DMS']);

      //check if API supports CPP configurations
      privacyProtectionSupport?.[apiId] && setStepList(s => [...s, 'Configure CPP']);

      //check if API has dealer API preferences
      dealerApiPreferences?.[apiId] && setStepList(s => [...s, 'Manage API Subscription Settings']);

      //check if API supports Vertical Scoping
      apiFieldSelections?.[apiId] && setStepList(s => [...s, 'Configure Fields']);
      
    }, [apiDetails]);

    const getDMSAccountForEachEntity = (dmsData, api) => {
      let dmsLocData = [];
      dmsData.map((l) => {
        let commonData = {
          location: l.location,
          cmfNumber: l.cmfNumber,
          entityId: l.entityId,
          api,
        };
        l.departments.map((dep) => {
          dmsLocData.push({
            ...commonData,
            type: dep.name,
            dmsAccountType: dep.type,
            departments: dep.accounts
              .map((a) => {
                if (a.isVisited) {
                  return {
                    name: a.name,
                    id: a.id,
                  };
                }
                return undefined;
              })
              .filter((e) => e != undefined),
          });
        });
      });
      return dmsLocData;
    };

    const dmsAccountEntityData = (departments) => {
      let entityData = [];
      departments.map(dep => {
        dep.accounts.map(a => {
          if(a.isVisited){
            entityData.push({
              name: a.name,
              id: a.id,
              dmsType: dep.name,
            })
          }
        })
      })
      return entityData;
    }
    const getBulkSubscribedDMSConfigForEachEntity = (dmsConfig) => {
      let data = {}
      Object.keys(dmsConfig).map(entityId => {
        data[entityId] = dmsAccountEntityData(dmsConfig[entityId]);
      })
      return data;
    };

    useEffect(() => {
      // toast notification
      // enable disable success toasts
      if (enableSuccess && !toastTriggered.enableSuccess) {
        setToastTriggered((ps) => {
          return {
          ...ps,
          enableSuccess: true
        }})
        enableToast();
      }
      if (disableSuccess && !toastTriggered.disableSuccess) {
        setToastTriggered((ps) => {
          return {
          ...ps,
          disableSuccess: true
        }})
        setShowDeactivationDialog(false);
        disableToast()
      }
      if (enableFailed && !toastTriggered.enableFailed) {
        setToastTriggered((ps) => {
          return {
          ...ps,
          enableFailed: true
        }})
        enableFailedToast();
      }
      if (disableFailed && !toastTriggered.disableFailed) {
        setToastTriggered((ps) => {
          return {
          ...ps,
          disableFailed: true
        }})
        disableFailedToast();
      }

      if(apiCppEnabled){
        if (updateCppError && !toastTriggered.cppFailed){
          setToastTriggered((ps) => {
            return {
            ...ps,
            cppFailed: true
          }})
          cppFailedToast();
        } else if(updateCppSuccess && !toastTriggered.cppSuccess){
          setToastTriggered((ps) => {
            return {
            ...ps,
            cppSuccess: true
          }})
          cppToast();
        }
      }
    }, [enableSuccess, disableSuccess, enableFailed, disableFailed, updateCppPending])

    useEffect(() => {
      setSteps(stepList?.map(s => ({label: s})));
      setStepNumberToContentMap(contentMapper(stepList));
    }, [stepList]);

    useEffect(() => {
      setIsLastStep(activeStep === stepList.length);
      getLocations();
    }, [activeStep]);

    //Change error
    const getComponent = activeStep => stepNumberToContentMap[activeStep] ? stepNumberToContentMap[activeStep]() : <div>Error loading component</div>;

    return (
      <>
        { (enablePending || disablePending || updateCppPending) && !showDeactivationDialog ? (
          <Loader className="dms_loader" label={'Saving...'}/>
        ) : (
          <>          
            <Overlay
              active={showDeactivationDialog}
              title={'Deactivation confirmation'}
              onOverlayClose={() => setShowDeactivationDialog(false)}
              onOverlayAccept={() => handleSave()}
              firstButtonText={'Cancel'}
              secondButtonText={disablePending ? <Loader label={'Deactivating'} style={{stroke: COLOR_STROKE}}/> : 'Deactivate'}
              customeStyle={CUSTOM_STYLE}
            >
              <div className={'unsubscribe-overlay-body'}>Are you sure you want to deactivate integration?</div>
            </Overlay> 
            <div className="manage-integrations-v2-container">
              <StepContainer className="step__container">
                <StepWrapper className="step__wrapper">
                  {steps.map((s, i) => {
                    const index = ++i;
                    const lastStep = index === steps.length;
                    return (
                      <React.Fragment key={index}>
                        <Step
                          isActive={activeStep === index}
                          isComplete={activeStep > index}
                        >
                          <StepIcon stepNumber={index} />
                          <StepLabelContainer>
                            <StepPrimaryLabel>
                              <label className="step__label">{s.label}</label>
                            </StepPrimaryLabel>
                          </StepLabelContainer>
                        </Step>
                        {!lastStep && <StepConnector />}
                      </React.Fragment>
                    );
                  })}
                </StepWrapper>
                <StepProgressBar
                  totalSteps={stepList.length}
                  currentStep={activeStep}
                />
              </StepContainer>
              <StepContent className="step__content">
                {React.cloneElement(getComponent(activeStep), {
                  apiDetails,
                  apiIntegrationDetails,
                  subscriptionData,
                  isNewApi,
                  solutionData
                })
              } 
            </StepContent>
            <div className='button__container'>
              <Button
                  className='button__previous'
                  data-testid='previous-button'
                  onClick={() => setActiveStep((s) => s - 1)}
                  text="Previous"
                  icon={<IconChevronLeft />}
                  variant={BUTTON_VARIANTS.SECONDARY}
                  isDisabled={activeStep === 1}
                />
                <Button
                  className={isLastStep ? 'button__save' : 'button__next'}
                  data-testid='next-button'
                  onClick={handleNavigation}
                  isDisabled={disableNext}
                  text={isLastStep ? 'Save' : 'Next'}
                  icon={isLastStep ? null : <IconChevronRight />}
                  isIconTrailing
                  variant={BUTTON_VARIANTS.PRIMARY}
                />
              </div>
            </div>
          </>
        )}
        <MultiToasts
          position={TOAST_POSITIONS.FIXED}
          style={{ marginTop: '70px' }}
          items={toasts}
        />
      </>
    );
};